export default "__VITE_ASSET__Qx8_XOdY__"